<template>
  <z-form ref="form" tag="div">
    <div class="row">
      <z-form-input class="col-8" :rules="{ required: true }" mode="passive_aggressive">
        <i-select v-model="sip_account_id">
          <i-option
            v-for="sip in sip_accounts"
            :key="sip.id"
            :label="sip.format_name"
            :value="sip.id"
          />
        </i-select>
      </z-form-input>
      <div class="col-4">
        <i-button type="primary" :long="true" :loading="is_loading" @click="submit">
          {{ $t('shared.component.button.add') }}
        </i-button>
      </div>
    </div>
  </z-form>
</template>

<script>
  import { SipAccountService } from '@pbx/services/SipAccountService';
  import { isSIP } from '@pbx/helpers/contact-methods';

  export default {
    props: {
      exist: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        sip_account_id: null,
        is_loading: false,
        free_sips: []
      };
    },

    computed: {
      exist_sip_accounts: function() {
        return this.exist.filter(account => isSIP(account));
      },

      sip_accounts: function() {
        /** Возвращаем только те сипы. которые еще не добавлены в список */
        return this.free_sips.filter(item => !this.is_exist(item.id));
      }
    },

    created() {
      SipAccountService.getFreeSipsOnlySelect().then(res => (this.free_sips = res));
    },

    methods: {
      get_contact_method(id) {
        const sip = this.sip_accounts.find(source => source.id === id);
        return { ...sip, sip_account_id: id };
      },

      is_exist: function(id) {
        const exist_ids = this.exist_sip_accounts.map(i => i.id);
        return exist_ids.includes(id);
      },

      submit: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const id = this.sip_account_id;
            this.is_loading = true;
            this.sip_account_id = null;

            const contact_method = this.get_contact_method(id);
            this.$emit('on-add', contact_method);

            this.$refs.form.reset();
            this.is_loading = false;
          }
        });
      }
    }
  };
</script>
